export default __webpack_public_path__ + "static/media/table_placeholder.171dacb4.png";